import { doc, onSnapshot, runTransaction, serverTimestamp } from "firebase/firestore";
import { db } from "./firebase";

function slugPart(s) {
  return (s || "")
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "") || "unknown";
}

export function releaseKeyFor(artist, albumTitle) {
  return `${slugPart(artist)}--${slugPart(albumTitle)}`;
}

export function subscribeToRelease(releaseId, callback) {
  return onSnapshot(doc(db, "releases", releaseId), (snap) => {
    callback(snap.exists() ? { id: snap.id, ...snap.data() } : null);
  });
}

export function subscribeToUserReleaseRating(releaseId, userId, callback) {
  return onSnapshot(doc(db, "releases", releaseId, "ratings", userId), (snap) => {
    callback(snap.exists() ? snap.data().rating : 0);
  });
}

export async function submitReleaseRating(releaseId, userId, artist, albumTitle, rating) {
  const releaseDocRef = doc(db, "releases", releaseId);
  const userRatingRef = doc(db, "releases", releaseId, "ratings", userId);

  await runTransaction(db, async (tx) => {
    const [releaseSnap, userRatingSnap] = await Promise.all([
      tx.get(releaseDocRef),
      tx.get(userRatingRef),
    ]);

    const prevRating = userRatingSnap.exists() ? userRatingSnap.data().rating : 0;
    const current = releaseSnap.exists()
      ? releaseSnap.data()
      : { ratingSum: 0, ratingCount: 0 };

    let ratingSum = current.ratingSum || 0;
    let ratingCount = current.ratingCount || 0;

    if (rating === 0 && prevRating > 0) {
      ratingSum -= prevRating;
      ratingCount -= 1;
    } else if (rating > 0 && prevRating === 0) {
      ratingSum += rating;
      ratingCount += 1;
    } else if (rating > 0 && prevRating > 0) {
      ratingSum += rating - prevRating;
    }

    const ratingAverage = ratingCount > 0 ? ratingSum / ratingCount : 0;

    tx.set(releaseDocRef, {
      artist,
      albumTitle,
      ratingSum,
      ratingCount,
      ratingAverage,
      updatedAt: serverTimestamp(),
    }, { merge: true });

    if (rating === 0) {
      tx.set(userRatingRef, { rating: 0, updatedAt: serverTimestamp() }, { merge: true });
    } else {
      tx.set(userRatingRef, { rating, updatedAt: serverTimestamp() }, { merge: true });
    }
  });
}
